import { formatDateToString } from '@/helpers/string';
import { Text } from '@mantine/core';

/**
 * transform to expiry date text with coloring if expired or near expiry
 * @param {string|Date} d
 * @returns {JSX.Element|string}
 */
const expiryDateTransform = (d = '') => {
  if (!d) return '';

  const dateValue = new Date(d);
  const oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);

  if (dateValue >= oneMonthFromNow) {
    return <Text size='sm'>{formatDateToString(dateValue)}</Text>;
  }

  return <Text c="red" size='sm'>{formatDateToString(dateValue)}</Text>;
};

export default expiryDateTransform;
